import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import PromoBanner from '../components/PromoBanner';
import Categories from '../components/Categories';
import FeaturedProducts from '../components/FeaturedProducts';
import PricingSection from '../components/PricingSection';
import FreeSystems from '../components/FreeSystems';
import CustomSystemCTA from '../components/CustomSystemCTA';
import FAQSection from '../components/FAQSection';
import CommunityCTA from '../components/CommunityCTA';
import Footer from '../components/Footer';
import TrustBar from '../components/TrustBar';
import Features from '../components/Features';
import TechMarquee from '../components/TechMarquee';
import Process from '../components/Process';
import Testimonials from '../components/Testimonials';
import ReferencesSection from '../components/ReferencesSection';
import GallerySection from '../components/GallerySection';
import BlogSection from '../components/BlogSection';
import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';

export default function Home() {
  const { meta, tr } = useI18n();
  useEffect(() => {
    document.title = `${meta?.settings?.site_title || 'Aegis Studios'} — Metin2 Server Files, Sistemler, Hosting & VPS`;
  }, [meta]);

  return (
    <main className="relative min-h-screen bg-[#08080b] text-[#e7e5e0] overflow-x-clip">
      <Seo />
      <Header />
      <Hero />
      <TrustBar />
      <PromoBanner />
      <Categories />
      <Features />
      <FeaturedProducts />
      <GallerySection />
      <BlogSection />
      <TechMarquee />
      <PricingSection eyebrow={tr('home.hosting_eyebrow', 'WEB HOSTING')} title={tr('pricing.hosting_title', 'Hızlı, Güvenli, Ölçeklenebilir')} subtitle={tr('home.hosting_sub', 'Metin2 sunucuları ve web projeleri için optimize edilmiş LiteSpeed altyapısı.')} ctaLabel={tr('home.hosting_cta', 'Tüm Hosting Paketleri')} ctaHref="/hosting" serverType="hosting" />
      <PricingSection eyebrow={tr('home.vps_eyebrow', 'SANAL SUNUCULAR (VPS)')} title={tr('home.vps_title', 'Cosmic VPS Serisi')} subtitle={tr('home.vps_sub', 'AMD Ryzen 7950X3D destekli, DDoS korumalı yüksek performanslı sanal sunucular.')} ctaLabel={tr('home.vps_cta', 'Tüm VPS Paketleri')} ctaHref="/vps" serverType="server" />
      <PricingSection eyebrow={tr('home.vds_eyebrow', 'FİZİKSEL SUNUCULAR (VDS)')} title={tr('home.vds_title', 'Rakipsiz Oyun Performansı')} subtitle={tr('home.vds_sub', 'Yüksek seviyeli izole kaynaklarla oyun sunucuları için kurşungeçirmez güç.')} ctaLabel={tr('home.vds_cta', 'Tüm VDS Paketleri')} ctaHref="/vds" serverType="vds" />
      <Process />
      <FreeSystems />
      <ReferencesSection />
      <Testimonials />
      <CustomSystemCTA />
      <FAQSection limit={6} />
      <CommunityCTA />
      <Footer />
    </main>
  );
}
